import { Theme } from '@mui/material'
import Select from '@mui/material/Select'
import { SxProps } from '@mui/system'
import { countries } from 'country-flag-icons'
import { CountryCode } from 'libphonenumber-js'
import dynamic from 'next/dynamic'
import {
  CountryCodeContainer,
  PhoneLocalMenuItemContainer,
  PhoneLocalMenuItemContainerProps,
  PhoneNumberSelectSXProps,
  sxInputProps,
  sxPaperProps
} from './PhoneNumberInput.style'

const phoneLocaleOptions = countries
  .filter((countryCode) => !['EU'].includes(countryCode))
  .map((countryCode) => ({
    countryCode
  }))

const PhoneNumberInputOption = dynamic(() =>
  import('./PhoneNumberInputOption').then((mod) => mod.PhoneNumberInputOption)
)

const PhoneNumberInputFlagImage = dynamic(() =>
  import('./PhoneNumberInputOption').then(
    (mod) => mod.PhoneNumberInputFlagImage
  )
)

interface PhoneCountriesProps {
  selectedPhoneLocale: CountryCode
  setSelectedPhoneLocale: React.Dispatch<React.SetStateAction<CountryCode>>
  customSxProps?: SxProps<Theme>
  variant?: PhoneLocalMenuItemContainerProps['variant']
  disabled?: boolean
}
const PhoneCountries = ({
  selectedPhoneLocale,
  setSelectedPhoneLocale,
  customSxProps,
  variant,
  disabled
}: PhoneCountriesProps) => {
  return (
    <Select
      sx={customSxProps || PhoneNumberSelectSXProps}
      IconComponent={() => <></>}
      inputProps={{ sx: sxInputProps }}
      MenuProps={{ PaperProps: { sx: sxPaperProps } }}
      value={selectedPhoneLocale}
      onChange={(event) =>
        setSelectedPhoneLocale(event.target.value as CountryCode)
      }
      renderValue={(countryCode) => (
        <PhoneLocalMenuItemContainer variant={variant ?? 'VALUE'}>
          <PhoneNumberInputFlagImage
            countryCode={countryCode}
          ></PhoneNumberInputFlagImage>
          <CountryCodeContainer>{countryCode}</CountryCodeContainer>
        </PhoneLocalMenuItemContainer>
      )}
      disabled={disabled}
    >
      {phoneLocaleOptions.map((option) => {
        return (
          <PhoneNumberInputOption
            key={option.countryCode}
            value={option.countryCode}
          ></PhoneNumberInputOption>
        )
      })}
    </Select>
  )
}

export default PhoneCountries
